import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1, A as ARROW_LEFT_24 } from './mapy-icon3.js';
import { g as getLocale, z as classNames, l as transDialog, k as getTheme } from './utils2.js';
import { k as MAX_PHOTOS_PER_LINE, h as MAX_TEXT_LENGTH, i as LAST_TEXT_LENGTH, d as DIALOG_PAGES } from './const.js';
import { d as defineCustomElement$9 } from './mapy-icon2.js';
import { d as defineCustomElement$8 } from './mapy-loader2.js';
import { d as defineCustomElement$7 } from './mapy-review-button2.js';
import { d as defineCustomElement$6 } from './mapy-review-dialog-footer2.js';
import { d as defineCustomElement$5 } from './mapy-review-photo-item2.js';
import { d as defineCustomElement$4 } from './mapy-review-photos-upload2.js';
import { d as defineCustomElement$3 } from './mapy-review-stars2.js';
import { d as defineCustomElement$2 } from './mapy-review-textarea2.js';

const mapyReviewDialogPageTextPhotoCss = ".mapy-review-dialog-page-text-photo{padding:0;display:flex;flex-direction:column;position:relative;height:100%;overflow:hidden;border-radius:12px}.header{display:flex;gap:8px;flex-direction:column;align-items:center;justify-content:center;width:100%}.header .title{margin:0;font-size:20px;font-style:normal;font-weight:700;line-height:28px;text-align:center;padding:0 25px}.back-button{padding:0;margin:0;position:absolute;left:12px;top:12px;border:none;background:transparent;color:#828282;border-radius:50%;cursor:pointer;z-index:10}.back-button mapy-icon{display:block}.back-button:hover,.back-button:focus{background:#f2f2f2}mapy-review-dialog-footer{width:100%}.textArea{width:100%;box-sizing:border-box}.textArea mapy-review-textarea{width:100%}.photos{width:100%}.scrollable{padding:48px 0 0 0;display:flex;flex-direction:column;gap:24px;justify-content:space-between;height:100%;box-sizing:border-box;font-family:Arial;align-items:center;position:relative;box-sizing:border-box;overflow:auto}.header,.textArea,.photos{width:100%;padding:0 32px;box-sizing:border-box}.footer{width:100%;padding:0 32px;box-sizing:border-box}.mapy-review-dialog-page-text-photo.is-sticky .scrollable{padding-top:23px}.mapy-review-dialog-page-text-photo.is-sticky .footer{position:sticky;left:0;right:0;bottom:0;background:#fff;z-index:10;padding-top:24px;box-shadow:0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2)}@media only screen and (max-width: 500px){.header,.textArea,.photos{width:100%;padding:0 16px;box-sizing:border-box}.footer{width:100%;padding:0 16px;box-sizing:border-box}.scrollable{padding:24px 0 0 0}.mapy-review-dialog-page-text-photo.is-sticky .footer{padding-top:16px}}";
const MapyReviewDialogPageTextPhotoStyle0 = mapyReviewDialogPageTextPhotoCss;

defineCustomElement$1();
const MapyReviewDialogPageTextPhoto = /*@__PURE__*/ proxyCustomElement(class MapyReviewDialogPageTextPhoto extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.signal = createEvent(this, "signal", 1);
        this.back = createEvent(this, "back", 3);
        this.save = createEvent(this, "save", 1);
        this.photoLoading = createEvent(this, "photoLoading", 1);
        this.onBack = () => {
            this.back.emit(this.getSaveData());
        };
        this.onSignal = (signal) => {
            this.signal.emit(signal.detail);
        };
        this.onTextChange = (event) => {
            this.reviewText = event.detail;
        };
        this.onFooterSave = () => {
            this.onSave();
        };
        this.onSave = () => {
            this.save.emit(this.getSaveData());
        };
        this.onUploadStart = (event) => {
            this.photoError = "";
            this.photosAreLoading = true;
            this.photoLoading.emit(true);
            this.signal.emit({
                name: "upload-start",
                count: event.detail,
            });
        };
        this.onPhotosCountChange = (event) => {
            this.isSticky = event.detail > MAX_PHOTOS_PER_LINE;
        };
        this.onPhotosChange = (event) => {
            this.curPhotos = event.detail.photos;
            this.photosAreLoading = false;
            this.photoLoading.emit(false);
        };
        this.onBlurWithText = () => {
            this.signal.emit({
                name: "textarea-blur",
            });
        };
        this.onPhotosError = (event) => {
            this.photoError = event.detail.error;
        };
        this.loading = false;
        this.isFirm = false;
        this.rating = 0;
        this.error = "";
        this.backButton = true;
        this.maxLength = MAX_TEXT_LENGTH;
        this.lastLength = LAST_TEXT_LENGTH;
        this.endpoint = "";
        this.apiKey = "";
        this.text = "";
        this.debug = false;
        this.photos = [];
        this.service = "mapy";
        this.isResponsive = false;
        this.anonymous = false;
        this.reviewText = "";
        this.isSticky = false;
        this.photosAreLoading = false;
        this.photoError = "";
        this.curPhotos = [];
    }
    getSaveData() {
        return {
            page: DIALOG_PAGES.TEXT_PHOTO,
            text: this.reviewText,
            media_ids: this.curPhotos.map(item => item.mediaId),
            photos: this.curPhotos,
        };
    }
    componentWillLoad() {
        this.reviewText = this.text;
        this.curPhotos = this.photos.slice();
    }
    render() {
        const locale = getLocale(this.hostElement);
        const theme = getTheme(this.service);
        return h(Host, { key: 'efafd14973b6be4703a4ab8440641753b73fd777' }, h("div", { key: '874b8b72419bce8c7477e8c74a68c5ff132aaf2e', class: classNames(["mapy-review-dialog-page-text-photo", this.isSticky || this.isResponsive ? "is-sticky" : ""]) }, (this.backButton && !this.photosAreLoading) && h("button", { key: 'e5c906fc1c41fcd450966e1e09268b5e7c7c194f', type: "button", class: "back-button", onClick: this.onBack }, h("mapy-icon", { key: 'b2c9110cd4479f72cf297922ae40df225bd97c4a', size: ARROW_LEFT_24.size }, h("path", { key: '0c0a82b3361a4080ef08f5cb03adc7a1bd740ee6', d: ARROW_LEFT_24.d }))), h("div", { key: 'b58e61a8edaa3b1c6c137f8024890712bb2124c5', class: "scrollable" }, h("div", { key: 'ce5060f09ee834e652c6a80edc1381c5ca0d9f4c', class: "header" }, h("mapy-review-stars", { key: '04cc6eb6f23017c6d448bac8bd04f7e954beea37', value: this.rating, size: 20, gap: 3, disabled: true }), this.service === "mapy" && h("h3", { key: '17de9dcece0040f07529ca876b045b5db074c679', class: "title" }, transDialog(locale, "motivateToComment"))), h("div", { key: 'fc4cb576b07ec13ff0af33e6c5ac9adb0abb033a', class: "textArea" }, h("mapy-review-textarea", { key: '4f1ba528afc56c3a2b9f1a8554270f12781ba325', value: this.reviewText, onChange: this.onTextChange, height: theme === "mapy" ? 154 : 204, maxLength: this.maxLength, lastLength: this.lastLength, lang: locale, service: this.service, onBlurWithText: this.onBlurWithText })), h("div", { key: '3d241bd72be5e35074c120b9a4d14c6d1f99d106', class: "photos" }, h("mapy-review-photos-upload", { key: '961a93c9112f8506390cc434933afde44eb0f2c3', endpoint: this.endpoint, apiKey: this.apiKey, photos: this.photos, debug: this.debug, onChange: this.onPhotosChange, onError: this.onPhotosError, onCountChange: this.onPhotosCountChange, onUploadStart: this.onUploadStart, lang: locale, service: this.service, onSignal: this.onSignal, anonymous: this.anonymous })), h("div", { key: '142316bcbab56ca4284df3c0041e141118217d05', class: "footer" }, h("mapy-review-dialog-footer", { key: '1d76106422099227abc1fcb5463d9f0766a4126f', isFirm: this.isFirm, hasButton: true, loading: this.loading, disabled: this.loading, lang: locale, service: this.service, hasPhotos: this.curPhotos.length > 0, onSave: this.onFooterSave, onSignal: this.onSignal, afterReview: true, hasReviewText: this.reviewText.length > 0, error: this.photoError || this.error })))));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewDialogPageTextPhotoStyle0; }
}, [1, "mapy-review-dialog-page-text-photo", {
        "loading": [516],
        "isFirm": [516, "is-firm"],
        "rating": [514],
        "error": [513],
        "backButton": [516, "back-button"],
        "maxLength": [514, "max-length"],
        "lastLength": [514, "last-length"],
        "endpoint": [513],
        "apiKey": [513, "api-key"],
        "text": [513],
        "debug": [516],
        "photos": [16],
        "service": [513],
        "isResponsive": [516, "is-responsive"],
        "anonymous": [516],
        "reviewText": [32],
        "isSticky": [32],
        "photosAreLoading": [32],
        "photoError": [32],
        "curPhotos": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-dialog-page-text-photo", "mapy-icon", "mapy-loader", "mapy-review-button", "mapy-review-dialog-footer", "mapy-review-photo-item", "mapy-review-photos-upload", "mapy-review-stars", "mapy-review-textarea"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-dialog-page-text-photo":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewDialogPageTextPhoto);
            }
            break;
        case "mapy-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "mapy-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "mapy-review-dialog-footer":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "mapy-review-photo-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "mapy-review-photos-upload":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "mapy-review-stars":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "mapy-review-textarea":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewDialogPageTextPhoto as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-dialog-page-text-photo2.js.map